module.exports = __webpack_public_path__ + "static/velocity-logo-5c8a66a68b6a33128e3b5ced0d33e854.png";